/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { SubmissionSummary } from './SubmissionSummary';
import {
    SubmissionSummaryFromJSON,
    SubmissionSummaryFromJSONTyped,
    SubmissionSummaryToJSON,
    SubmissionSummaryToJSONTyped,
} from './SubmissionSummary';

/**
 * 
 * @export
 * @interface SubmissionListResponse
 */
export interface SubmissionListResponse {
    /**
     * 
     */
    submissions: Array<SubmissionSummary>;
    /**
     * 
     */
    nextBefore: Date | null;
}

/**
 * Check if a given object implements the SubmissionListResponse interface.
 */
export function instanceOfSubmissionListResponse(value: object): value is SubmissionListResponse {
    if (!('submissions' in value) || value['submissions'] === undefined) return false;
    if ((!('nextBefore' in (value as Record<string, any>)) && !('next_before' in (value as Record<string, any>))) || ((value as Record<string, any>)['nextBefore'] === undefined && (value as Record<string, any>)['next_before'] === undefined)) return false;
    return true;
}

export function SubmissionListResponseFromJSON(json: any): SubmissionListResponse {
    return SubmissionListResponseFromJSONTyped(json, false);
}

export function SubmissionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'submissions': ((json['submissions'] as Array<any>).map(SubmissionSummaryFromJSON)),
        'nextBefore': (json['next_before'] == null ? null : parseDateTime(json['next_before'])),
    };
}

export function SubmissionListResponseToJSON(json: any): SubmissionListResponse {
    return SubmissionListResponseToJSONTyped(json, false);
}

export function SubmissionListResponseToJSONTyped(value?: SubmissionListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submissions': ((value['submissions'] as Array<any>).map(SubmissionSummaryToJSON)),
        'next_before': value['nextBefore'] == null ? value['nextBefore'] : serializeDateTime(value['nextBefore']),
    };
}

